module.exports = __webpack_public_path__ + "img/code.cc97d1a2.png";